interface AdminFilterBarProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
  onSubmit?: (e: React.FormEvent) => void;
}

export function AdminFilterBar({ children, actions, onSubmit }: AdminFilterBarProps) {
  const Wrapper = onSubmit ? "form" : "div";
  return (
    <Wrapper
      {...(onSubmit ? { role: "form", "aria-label": "Filters", onSubmit } : {})}
      className="flex flex-wrap items-center gap-3"
    >
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-3">{children}</div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </Wrapper>
  );
}
